<template>
  <div class="bb-tags-vendor"
       :class="{'bb-tags-vendor_table': table}"
  >
    <div class="bb-tags-vendor-container"
         v-for="(tag, index) in sortedTags"
         :key="tag.id"
         v-if="index <= limitCount"
    >
      <div
        class="bb-tags-vendor-container__item"
        :style="{
          color: `rgba(${tag.color}, 1)`,
          background: `rgba(${tag.color}, 0.15)`
        }"
      >
        {{tag.name}}
      </div>
      <div class="bb-tags-vendor-container__text"
           ref="iconPopup"
           @mouseenter="setPositionPopup($event)"
           @mouseleave="showPopup = false"
           v-if="index === limitCount && countAddedTags !== 0"
      >
        + more {{countAddedTags}}
        <transition name="bounce">
          <div
            v-if="showPopup"
            class="bb-tags-vendor-popup"
            :style="popupPosition"
          >
            <div
              class="bb-tags-vendor-popup__item"
              v-for="remainingTag in remainingTags"
              :key="remainingTag.id"
              :style="{
                color: `rgba(${remainingTag.color}, 1)`,
                background: `rgba(${remainingTag.color}, 0.15)`
              }"
            >
              {{remainingTag.name}}
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'TagsVendor',
  props: ['tags', 'limitCount', 'table', 'fixedPopup'],
  data () {
    return {
      showPopup: false,
      popupPosition: {}
    }
  },
  computed: {
    countAddedTags () {
      return this.tags.length - this.limitCount - 1
    },
    remainingTags () {
      return this.sortedTags.slice(this.limitCount + 1)
    },
    sortedTags () {
      return _.sortBy(this.tags, ['name'])
    }
  },
  methods: {
    setPositionPopup (e) {
      this.showPopup = true
      if (this.fixedPopup) {
        const box = e.target.getBoundingClientRect()
        this.popupPosition = {
          position: 'fixed',
          left: (box.left) + 'px',
          top: box.top + 30 + 'px'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../../sass/variables";
@import "../../../../../../sass/mixins";

.bb-tags-vendor {
  @include global-font;
  position: relative;
  max-width: 266px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  &_table {
    justify-content: flex-start;
  }

  &-popup {
    width: max-content;
    position: absolute;
    right: 0;
    top: 35px;
    z-index: 2;
    pointer-events: none;
    background: $color-alabaster;
    border-radius: 4px;
    box-shadow: 0 0 12px rgba($color-black, 0.12);

    &__item {
      width: max-content;
      margin: 12px;
      white-space: nowrap;
      padding: 3px 5px;
      color: $color-denim;
      line-height: 16px;
      background: rgba($color-accent, 0.2);
      border-radius: 3px;
      cursor: pointer;
      transition: 0.3s;
    }
  }

  &-container {
    display: inline-flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;

    &__item {
      white-space: nowrap;
      padding: 3px 5px;
      color: $color-denim;
      line-height: 16px;
      background: rgba($color-accent, 0.2);
      border-radius: 3px;
      cursor: pointer;
      transition: 0.3s;

      &:last-child {
        margin-right: 0;
      }

      &:hover {
        background: rgba($color-accent-hover, 0.2);
        color: $color-accent-hover;
      }
    }

    &__text {
      position: relative;
      padding-top: 2px;
      margin-left: 6px;
      font-weight: 500;
      font-size: 12px;
      line-height: 150%;
      color: $color-silver;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactServiceProvider/TagsVendor.vue